import { useContext } from 'react';

import {
    ADD_CART,
    REFRESH_CART,
    REMOVE_CART,
} from '../constants';
import { CartContext } from '../context/CartContext';

const createCartProvider = (dispatch, checkAndAddCart) => () => {
    const addToCart = ({ skuId }) => dispatch({ type: ADD_CART, payload: { skuId } });
    const removeFromCart = (skuId) => dispatch({ type: REMOVE_CART, payload: { skuId } });
    const refreshCart = (cartItems) => dispatch({ type: REFRESH_CART, payload: { cartItems } });

    return { addToCart, removeFromCart, refreshCart, checkAndAddCart };
};

export const useCart = () => {
    const { dispatch, checkAndAddCart } = useContext(CartContext);

    return createCartProvider(dispatch, checkAndAddCart);
};
